import {useEffect} from "react"
import Papa from "papaparse"
import makeCSV from "@irati/utils/csv/makeCSV"
import moment from "moment"
import {ListScheduledRewards} from "@irati/types"
import {useLazyUsersForBusiness} from "@irati/identity/hooks"
import authentication from "@irati/auth"

export function useDownloadReport(reward: ListScheduledRewards) {
  const [fetchUsers, apollo] = useLazyUsersForBusiness({
    businessId: authentication.business().uuid,
    userIds: reward.destinationIds,
    enabled: true
  })

  useEffect(() => {
    if (apollo.data && apollo.called) {
      const {uuid, amount, scheduledFor} = reward
      const date = moment.utc(scheduledFor.when).format("YYYY-MM-DD")
      const filename = `scheduled-${date}-rp-${amount / 100}_${uuid.slice(0, 5)}.csv`
      const csv = Papa.unparse({
        fields: ["firstName", "lastName", "email"],
        data: apollo.data.results
      })
      makeCSV(csv, filename)
    }
  }, [apollo, reward])

  return [fetchUsers, apollo] as const
}
